import { afterNextRender, ChangeDetectionStrategy, Component, computed, HostBinding, input, Input } from '@angular/core';
import { CommonModule } from 'src/common/common.module';
import { MenuConfiguration, Store } from 'src/common/models';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { StoreAddressComponent } from '../store-address/store-address.component';


@Component({
  selector: 'app-store-contact',
  templateUrl: './store-contact.component.html',
  styleUrls: ['./store-contact.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [CommonModule, StoreAddressComponent]
})
export class StoreContactComponent {
  store = input<Store>()
  _store = computed<Store | undefined>(() => {
    let inputStore = this.store();
    let configStore = ContentCacheUtils.menu<MenuConfiguration>()?.store;
    return inputStore ?? configStore;
  })
}
